<template>
    <div @touchmove.stop="">
        <div class="brt-poi-list-top-drawer" :class="state == 0 ? 'hide':'show'" ref="top" :style="getTopStyles" >
            <div class="l">
                <img v-if="dataCache.CATEGORY_ICON" :src="dataCache.CATEGORY_ICON" alt="">
                <span>{{ dataCache.NAME || '' }}</span>
            </div>
            <div :class="dataCache.NAME && dataCache.NAME.length > 6 ? 'c':'c show'" @click="changeState">
                共{{ poiArrayCache.length }}结果 分布{{ formatList.length }}层
            </div>
            <div class="r">
                <i class="iconfont icon-search"></i>
            </div>
        </div>

        <div class="brt-poi-list-bom-drawer" :class="state == 0 ? 'hide':'show'" ref="bom" :style="getBomStyles">
            <div class="brt-plb-head" ref="bom-head">

                <div class="style-2" v-show="state === 3">
                    <ColSelect :data="ColSelectData" @on-select="onColSelect"></ColSelect>
                </div>

                <div class="style-1" v-show="state !== 3" @click="changeState">

                    <div class="l">
                        本层<span>{{ poiArray.length }}</span> 共<span>{{ poiArrayCache.length }}</span> 分布<span>{{ formatList.length }}</span>层
                    </div>

                    <div class="r" @click.stop="dialogVisible = true">
                        楼层{{ selectFloorItem.floorName || currentFLoor.floorName}}
                    </div>
                </div>

            </div>


            <div class="brt-plb-body">
                <ul v-if="poiArray.length">
                    <li v-for="(item, index) in poiArray" v-show="(state !=3 && index<10) || state==3" @click="selecte(item)">
                        <div class="content">
                            <div class="t1">
                                {{ item.NAME }} {{ item.FLOOR_NAME }}
                                <!--<span :class="item.momCare.length == 0 ? 'momcare block':'momcare'" v-if="item.momCare">{{item.momCare.length}}间可用</span>-->
                                <!--<span class="distant" v-if="$BRT.$locate.point && item.isnear">距您最近</span>-->
                            </div>

                            <div class="t2">

                            {{ item.CATEGORY_NAME }} <span v-show="item.distance>0">{{item.distance}}米 {{item.cross ? '需跨层':''}}</span>

                                <!--声誉-->
                                <span  v-if="item.detail && item.detail.aptitudeList.length > 0">
                                    <img :src="icons.icon" alt="" v-for="icons in item.detail.aptitudeList" />
                                </span>
                            </div>

                            <Tags class="t3" v-if="item.activity || item.detail || item.theme_activity" :data="item" scroll></Tags>

                            <div class="t4" v-if="item.detail && item.detail.bussT.sTime && item.detail.bussT.eTime">
                                <i></i>
                                <!--<span>营业中，</span>-->
                                <span>营业时间 {{item.detail.bussT.sTime}} ~ {{item.detail.bussT.eTime}}</span>
                            </div>

                        </div>
                        <div class="right" v-if="item.detail && item.detail.LOGO">
                            <img class="logo" :src="item.detail.LOGO">
                        </div>
                    </li>
                </ul>

                <div class="none-box" v-else>
                    没有检索到结果！
                </div>
            </div>
        </div>

        <!--选择结果楼层-->
        <Dialog class="brt-search-dialog-1"  v-model="dialogVisible" title="选择结果楼层" title-background>
            <ul>
                <li v-for="(item, index) in formatList" @click="onSelectFloor(item)">
                    <span class="l">
                        {{ item.floorName }}

                        <span  v-if="$BRT.$locate.point.floor &&  item.floorNumber == $BRT.$locate.point.floor">您</span>
                    </span>
                    <span class="r">
                        <b>{{ item.list.length }}</b>
                        结果
                    </span>
                </li>
            </ul>
        </Dialog>

    </div>
</template>

<script>
    import {Tags} from '@/components/tags'
    import {ColSelect} from '@/modules/colSelect'
    import {Dialog} from '@/components/dialog'
    import {ResultFormat} from "@/utils/search_poi_format";
    import {_activityPoiExtend, _detailPoiExtend,CATEGORY_ICONExtend,_themeActivityPoiExtend} from "@/utils/search_poi_extend";

    export default {
        name: "PoiListDrawer",
        components: {
            Tags,
            Dialog,
            ColSelect
        },
        data() {
            return {
                state: this.value,
                isMounted: false,

                currentFLoor:{},

                //类别筛选 需缓存的poi数据
                classifyPoiCache: [],

                dataCache: {},        //分类数据

                poiArrayCache: [],      //缓存的所有poi数据
                poiArray: [],       //需展示的poi数据

                dialogVisible: false,
                formatList: [],     //格式化的poi数据(分楼层)
                selectFloorItem: {},//选中的楼层
                selectClassifyItem: {},
                selectActivityItem: {},

                // col select 选择
                ColSelectData: []
            }
        },

        props: {
            'value': {
                default: 0
            },
            'data': {
                default: {}
            }
        },

        watch: {
            value(val) {
                if (this.state != val) {
                    this.state = val;
                }
            },
            'data': {
                deep: false,
                immediate: false,

                handler(res) {

                    //console.log('筛选数据',res,'$VAR',$VAR);

                    res = Object.assign({},res);

                    this.reset();

                    if (res.children && res.children.length) {

                        let datas = res.children.filter(item => {
                            return !!item && !!item.NAME
                        });

                        //防止数据重复(根据POI_ID进行判断)
                        datas = datas.sort((item1,item2)=>{ return item1.POI_ID.localeCompare(item2.POI_ID) })
                        for(let i=0;i<datas.length - 1;i++){
                            if(datas[i+1].POI_ID && datas[i].POI_ID == datas[i+1].POI_ID){
                                datas.splice(i,1)
                            }
                        }

                        //检查是否有详情poi
                        datas = _detailPoiExtend(datas, this.$store.state.POI_DETAIL_DATA);

                        //检查是否有活动poi
                        datas = _activityPoiExtend(datas, this.$store.state.ACTIVITY_DATA);

                        //检查是否有主题活动
                        datas = _themeActivityPoiExtend(datas,this.$store.state.THEME_ACTIVITY_DATA[0]);
                        //类型图标
                        datas = CATEGORY_ICONExtend(datas);

                        this.poiArrayCache = datas.concat();

                        this.formatList = ResultFormat(datas);

                        //默认选择
                        let $PoiListData = this.$BRT.$options.PoiListData;
                        let $floorID = $PoiListData.floorID;

                        //防止当前楼层暂无数据 & 需要切换楼层
                        if(!this.formatList.some((item)=>{
                            return item.floorID == $floorID;
                        }) && $PoiListData.changeFloor){
                            let cf = '';
                            if(this.$BRT.$locate.point){
                                //取距离定位点最近的楼层
                                let pf = this.$BRT.$locate.point.floor,
                                    f = 99;

                                this.formatList.map(item=>{
                                    if(Math.abs(pf - item.floorNumber) < f){
                                        f = Math.abs(pf - item.floorNumber);
                                        cf = item.floorID
                                    }
                                })


                            }
                            else{
                                cf = this.formatList[0].floorID;
                            }
                            $floorID = cf;
                        }


                        if($floorID){

                            if($VAR.map.currentMapInfo.floorID != $floorID){

                                let $zoom = $VAR.map.getZoom();
                                $VAR.map.setFloor($floorID,()=>{
                                    $VAR.map.stop().easeTo({
                                        zoom:$zoom
                                    })
                                });

                            }

                            //是否有该楼层
                            let $isTrue = this.formatList.some((item)=>{

                                return item.floorID == $floorID;

                            })

                            if(!$isTrue){

                                this.$message.load(false)

                            }

                            for(let i=0;i<this.formatList.length;i++){

                                if(this.formatList[i].floorID == $floorID){

                                    this.onSelectFloor(this.formatList[i]);

                                }

                            }


                        }

                        else{

                            this.onSelectFloor(this.formatList[0]);

                        }

                    }

                    this.dataCache = res;

                    this.selectClassifyItem = {
                        label: res.NAME,
                        value: res.CATEGORY_ID
                    };

                    this._formatColSelect();

                }
            },



            $mapstepType(v1,v2){
                if(!v1){this.formatList=[]} //切换楼层插标
            }

        },

        computed: {
            getTopStyles() {
                let styles = {};

                if (this.isMounted) {

                    if (this.state === 3) {
                        styles.transform = styles.webkitTransform = 'translateY(0)';
                    }
                    else {
                        styles.transform = styles.webkitTransform = 'translateY(-110%)';
                    }

                }

                return styles;
            },

            getBomStyles() {
                let styles = {};

                if(!$height){   //初始获取，防止高度被卡顿干扰
                    var $height = window.innerHeight;
                }


                if (this.isMounted) {

                    if (this.state === 2) {
                        styles.height = ($height * 0.5) + 'px';
                    }
                    else if (this.state === 3) {
                        styles.height = ($height - this.$refs['top'].clientHeight) + 'px';
                    }
                    else {
                        styles.height = this.$refs['bom-head'].clientHeight + 'px';
                    }
                }

                return styles;
            },

            // $floor(){
            //     return $VAR.map.currentMapInfo.floorNumber
            // },

            $mapstepType(){
                return this.$BRT.$mapStep.type
            }

        },

        created(){

            this.bus.$off('colSelectedFilter');
            this.bus.$on('colSelectedFilter',()=>{this.$BRT.$options.PoiListData = this.dataCache})


            //切换数据
            this.bus.$off('colSelectedFloorFilter');
            this.bus.$on('colSelectedFloorFilter',(res)=>{
                this.changeFloor(res.floor);
            })

            //切换楼层方法
            this.bus.$off('PoiListDrawerFloorListen')
            this.bus.$on('PoiListDrawerFloorListen',res=>{
                this.currentFLoor = Object.assign({},res);
                this.$floor(res.floorNumber);
            })

        },

        methods: {
            reset () {
                // 重置
                this.dataCache = {};
                this.ColSelectData = [];
                this.poiArrayCache = [];
                this.poiArray = [];
                this.formatList = [];

                this.selectFloorItem = {};
                this.selectClassifyItem = {};
                this.selectActivityItem = {};
            },

            $floor(v1,v2){
                this.changeFloor(v1);
            },

            changeState() {
                this.state++;

                if (this.state > 3) {this.state = 2;}


                this.$emit('input', this.state);
            },

            changeFloor($floor){

                if(this.$mapStep.type == 'toFilter' || this.$mapStep.type == 'selectePOI'){

                    for(let i=0;i<this.formatList.length;i++){

                        //防止选点时POI(筛选)
                        if(this.formatList[i].floorNumber == $floor && (this.$mapStep.type == 'selectePOI' || this.$BRT.$urlParam.filter.status)){this.onSelectFloor(this.formatList[i])}

                    }

                    //同步数据
                    if(this.$mapStep.type == 'toFilter'){
                        this._formatColSelect();
                    }

                }
            },

            //格式化 col select
            _formatColSelect () {

                if (this.dataCache.CATEGORY_ID) {

                    this.ColSelectData = [];

                    this._formatColSelectByFloor();

                    //普通搜索
                    if (this.dataCache.CATEGORY_ID === '99') {
                        this._formatColSelectByActivity();
                    }
                    //是否  00:辅助设施   11:交通服务   15:通行设施    16:公共设施 大类
                    else if (['00', '11', '15', '16'].indexOf(this.dataCache.CATEGORY_ID.substr(0, 2)) > -1) {
                        this._formatColSelectByClassify();
                    }
                    else {
                        this._formatColSelectByClassify();
                        this._formatColSelectByActivity();
                    }
                }

            },

            _formatColSelectByFloor() {
                let floorArray = [];

                this.formatList.map(item => {
                    let json = {
                        label: item.floorName,
                        value: item.floorID
                    };
                    if (this.selectFloorItem.floorID === item.floorID) {
                        json.selected = true;
                    }
                    floorArray.push(json);
                });

                this.ColSelectData.push(floorArray);
            },

            _formatColSelectByClassify() {

                let brtmapSearch = $VAR.brtmapSearch, searchArray = [];

                let _callee = (array, id) => {
                    for (let i = 0; i < array.length; i++) {
                        if (array[i].value === id) {
                            return array[i];
                        }
                        else {
                            let obj = _callee(array[i].children, id);
                            if (obj) {
                                return array[i];
                            }
                        }
                    }
                };

                if (brtmapSearch._poiTypeCache) {

                    let classifyArray = [
                        {
                            label: '全部分类',
                            value: 'C-all',
                            children: [
                                {
                                    label: '全部',
                                    value: 'CA-all',
                                    children: []
                                }
                            ]
                        }
                    ];

                    let classify = _callee(JSON.parse(JSON.stringify(brtmapSearch._poiTypeCache)), this.dataCache.CATEGORY_ID);

                    //格式化分类筛选
                    classify.children.map(child => {

                        if (child.children[0].value.indexOf('all') < 0) {
                            child.children.unshift({
                                label: '全部',
                                value: child.value + '-all',
                                children: []
                            });
                        }

                        if (child.value === this.selectClassifyItem.value) {
                            child.selected = true;
                        }

                        child.children.map(child2 => {
                            if (child2.value === this.selectClassifyItem.value) {
                                child.selected = true;
                                child2.selected = true;
                            }

                            brtmapSearch.query({
                                type: 'cid',
                                value: child2.value
                            }, res => {

                                //排除不可用数据
                                res = res.filter(item=>{
                                    let isTrue = true;
                                    if(item.CATEGORY_ID.length >= 4 && Math.round(item.CATEGORY_ID) < 1200)isTrue = false;

                                    //排除门、大类、不满足的数据
                                    return isTrue ; //isTrue && item.CATEGORY_ID != '150015'
                                });

                                //检查是否有详情poi
                                res = _detailPoiExtend(res, this.$store.state.POI_DETAIL_DATA);
                                //检查是否有活动poi
                                res = _activityPoiExtend(res, this.$store.state.ACTIVITY_DATA);
                                //检查是否有主题活动
                                res = _themeActivityPoiExtend(res,this.$store.state.THEME_ACTIVITY_DATA[0])
                                //类型图标
                                res = CATEGORY_ICONExtend(res);

                                searchArray = searchArray.concat(res);
                            });

                        });

                        classifyArray.push(child);
                    });

                    //缓存类别下所有数据
                    this.classifyPoiCache = searchArray.filter(item => {
                        return !!item.NAME;
                    });

                    this.ColSelectData.push(classifyArray);
                }

            },

            _formatColSelectByActivity() {

                let activityArray = [
                    {
                        label: '全部',
                        value: 'P-all'
                    },
                    {
                        label: '只看有活动',
                        value: 'activity',
                        selected:this.selectActivityItem.value === 'activity' ? true : false
                    }
                ];

                this.ColSelectData.push(activityArray);
            },

            //楼层选择
            onSelectFloor(item) {

                this.$message.load(true);

                //计算距离获取最近距离
                if(this.$BRT.$locate.point){

                    //防止重复计算
                    let hasDistance = this.poiArrayCache.some(($item)=>{return !!$item.distance})

                    if(!hasDistance){

                        for(let i=0;i<this.poiArrayCache.length;i++){

                            this.bus.$emit('getDistant',{
                                type:1,
                                point:this.poiArrayCache[i],
                                callback:(data)=>{
                                    this.poiArrayCache[i].distance  = data ?  data.distance :null;
                                    this.poiArrayCache[i].cross =data ? data.cross : null;
                                }
                            })

                        }

                        //排序
                        this.poiArrayCache = this.poiArrayCache.sort((v1,v2)=>{return v1.distance - v2.distance });
                    }


                    //计算距离(防止重复计算)
                    let hasFloorDistance = item.list.some(($item)=>{return !!$item.distance})
                    if(!hasFloorDistance){

                        for(let i=0;i<item.list.length;i++){

                            this.bus.$emit('getDistant',{
                                type:1,
                                point:item.list[i],
                                callback:(data)=>{
                                    item.list[i].distance  = data ?  data.distance :null;
                                    item.list[i].cross =data ? data.cross : null;
                                }
                            })

                        }

                    }

                    //显示最近距离
                    if(item.floorNumber == this.poiArrayCache[0].FLOOR_NUMBER){

                        item.list.map(($item,index)=>{

                            if($item.POI_ID == this.poiArrayCache[0].POI_ID){

                                item.list[index].isnear = true;

                            }else{

                                item.list[index].isnear = false;

                            }

                        })
                    }


                }

                //特殊处理(需要初始显示又需要定位后再次处理)
                if(this.$BRT.$urlParam.filter.status){

                    if(this.$BRT.$locate.point){
                        this.$BRT.$urlParam.filter.status = false;
                        this.$BRT.$urlParam.filter.name = '';
                        this.$BRT.$urlParam.filter.resetName = '';
                        setTimeout(()=>{this.$message.load(false)},0)
                    }


                }
                else{

                    setTimeout(()=>{this.$message.load(false)},0)

                }


                this.selectFloorItem = item;
                this.dialogVisible = false;

                //新增号馆

                for(let i=0;i<item.list.length;i++){

                    let r = item.list[i];

                    //拼接号馆
                    if(r && r.REGION && r.NAME && r.NAME.indexOf(r.REGION) === -1){
                        r.NAME = r.REGION  +  r.NAME;
                    }

                    /*
                    if(r.NAME.indexOf('号馆') == -1 && r.ZONE_ID){

                        $VAR.brtmapSearch.query({
                            type:'poiid',  //'poiid'
                            value:r.ZONE_ID
                        }, function (result) {

                            if(result.length && result[0].NAME.indexOf('号馆')> -1){
                                item.list[i].NAME = result[0].NAME + item.list[i].NAME;
                            }
                        })
                    }
                    */
                }


                // if(item.list.length && item.list.length>10){item.list = item.list.slice(0,10)}

                //切换楼层
                if(item.list.length && $VAR.map.currentMapInfo.floorNumber !=item.list[0].FLOOR_NUMBER){

                    let $zoom = $VAR.map.getZoom();
                    $VAR.map.setFloor(item.list[0].FLOOR_ID,()=>{
                        //第一个居中
                        $VAR.map.easeTo({
                            center:$VAR.map.coordsToLnglat(item.list[0].LABEL_X,item.list[0].LABEL_Y),
                            zoom:$zoom
                        })
                    })

                }

                else{
                    //第一个居中
                    $VAR.map.easeTo({
                        center:$VAR.map.coordsToLnglat(item.list[0].LABEL_X,item.list[0].LABEL_Y)
                    })
                }

                //插标(先清空)
                this.$BRT.$marker.selected.empty();

                let poiMarkers = $VAR.PoiListMaker;

                if(poiMarkers.length){
                    for(let i=0;i<poiMarkers.length;i++){
                        if(poiMarkers[i] && poiMarkers[i].maker){
                            poiMarkers[i].maker.remove();
                        }
                    }
                }

                $VAR.PoiListMaker=[];

                let $MAKERS = [];



                /************插标最多插10个最近10个*****************/

                item.list = item.list.sort((v1,v2)=>{

                    return v1.distance - v2.distance;

                });

                this.poiArray = item.list;

                // console.log('item.list.length',item.list.length)

                let $len = item.list.length > 10 ? 10 : item.list.length;

                if($len >= 10){
                    this.$message.info('仅展示附近10个结果,可展开全部查看')
                }

                for(let i=0;i< $len;i++){

                    let $li = item.list[i];

                    let $maker = '';

                    $maker =new brtmap.Symbol.DivMarker({
                        content:'<div class="wrap"><div class="icon-box"><i class="poi-icon-' +$li.CATEGORY_ID+'" style="background-image: url('+$li.CATEGORY_ICON+')"></i></div></div>',
                        className:'filter-marker',
                        offset:[0,-10]
                    }).addTo($VAR.map).setLnglat($VAR.map.coordsToLnglat($li.LABEL_X,$li.LABEL_Y));

                    //绑定事件(选点)
                    $maker.on('click',(res)=>{
                        event.stopPropagation();
                        this.$mapStep.poiID = $li.POI_ID;
                        this.bus.$emit('selectedPoint',this.$mapStep.poiID);
                        this.$mapStep.type = 'selectePOI';
                        this.$BRT.$filter.enter = 'Filter';
                        this.$BRT.$options.PoiListDrawer = 0;

                    })

                    $MAKERS.push({item:$li,maker:$maker});
                }



                //console.log(' [...$MAKERS]', [...$MAKERS]);
                $VAR.PoiListMaker = [...$MAKERS];

                //格式化数据
                // this._formatColSelect();
            },

            onColSelect(res) {
                let floorItem = res[0],
                    classifyItem = res[1],
                    activityItem = res[2];

                if(!classifyItem.children) {
                    activityItem = classifyItem;
                    classifyItem = null;
                }

                // console.log('floorItem',floorItem,'classifyItem',classifyItem,'activityItem',activityItem);

                this.selectClassifyItem = classifyItem || {};
                this.selectActivityItem = activityItem || {};

                let filterResult = [];

                //活动筛选
                if(activityItem) {
                    let poiCache = classifyItem ? this.classifyPoiCache : this.poiArrayCache;

                    // console.log('poiCache',poiCache,'this.classifyPoiCache',this.classifyPoiCache,'this.poiArrayCache',this.poiArrayCache);

                    filterResult = poiCache.filter((item) => {

                        if (activityItem.value === 'P-all') {
                            return true;
                        }
                        else if (activityItem.value === 'activity') {
                            return !!item.activity || item.theme_activity.length
                        }
                        else {
                            return !item.activity
                        }
                    });

                }

                //类别筛选
                if(classifyItem) {

                    //公共设施类
                    if(!activityItem && filterResult.length == 0){filterResult = this.classifyPoiCache;}

                    filterResult = filterResult.filter((item) => {
                        if (classifyItem.value === 'C-all') {
                            return true;
                        }
                        else {
                            if (classifyItem.value.length >= 6) {
                                return classifyItem.value === item.CATEGORY_ID;
                            }
                            else {
                                return classifyItem.value === item.CATEGORY_ID.substr(0, 4);
                            }
                        }
                    });

                    filterResult = filterResult.concat();
                }

                // this.poiArrayCache = filterResult;
                this.formatList = ResultFormat(filterResult);

                if(classifyItem && classifyItem.label != '全部分类'){   //更改顶部提示

                    let $data = {
                        CATEGORY_ICON:`https://files.brtbeacon.net/BRTMap/images/${classifyItem.value}_normal.png`,
                        // CATEGORY_ID:classifyItem.value.match('C-') ? filterResult[0].CATEGORY_ID.slice(0,2) : classifyItem.value,
                        // LEVEL:3,
                        NAME:classifyItem.label,
                        children:filterResult,
                        // floorID:floorItem.value,
                    };

                    //顶部值修改
                    this.bus.$emit('filter_search_value',classifyItem.label)
                    //缓存数据更改
                    Object.assign(this.dataCache,$data);

                }

                // Object.assign(this.$BRT.$options.PoiListData,$data);

                //楼层筛选
                filterResult = this.formatList.filter(item => {
                    if (item.floorID === floorItem.value) {
                        return true;
                    }
                });


                if(filterResult.length) {

                    /*
                    * 筛选特殊操作可在这里处理数据
                    * */

                    this.onSelectFloor(filterResult[0]);

                    // this._formatColSelect();
                }
                else {
                    this.poiArray = [];
                }

            },

            //选中
            selecte(poi){

                //检索跟踪上传
                let retrievalTracking = this.$store.state.retrievalTracking;
                if(retrievalTracking.state && poi.CATEGORY_ID.indexOf(retrievalTracking.CATEGORY_ID) > -1){
                    this.$userUpdata.setSearch('',2,retrievalTracking.NAME);
                }

                this.$mapStep.poiID = poi.POI_ID;
                this.bus.$emit('selectedPoint',this.$mapStep.poiID);
                this.$mapStep.type = 'selectePOI';
                this.$BRT.$options.PoiListDrawer = 0;
                this.$BRT.$filter.enter = 'Filter';
            }
        },

        mounted() {
            this.isMounted = true;
        }
    }
</script>

<style lang="less">
    @import "../../styles/cssBlock.less";

    .absolute (@style) {
        position: absolute;
        left: 0;
        right: 0;
            @{style}: 0;
        z-index: 8000;
    }

    @topHeight: @120px;
    .brt-poi-list-top-drawer {
        .absolute(top);

        &.hide{
            display: none;
        };

        &.show{
            display: flex;
            justify-content: space-between;
        }

        position: fixed;
        pointer-events: auto;
        background-color: rgba(255, 255, 255, 0.8);
        height: @topHeight;
        line-height: @topHeight;
        transition: transform .2s linear;

        &:after {
            display: inline-block;
            font-family: iconfont !important;
            content: '\e6f4';
            line-height: @20px;
            position: absolute;
            bottom: @10px;
            left: 50%;
            transform: translateX(-50%);
            font-size: @26px;
            color: @fontColorA3;
        }

        > .l {
            /*float: left;*/
            color: @fontColorA1;
            padding: 0 @spacingNumber;

            max-width: 40%;
            flex-shrink: 0;

            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            > img {
                width: @38px;
                vertical-align: middle;
                position: relative;
                top: -2px;
                margin-right: @10px;
            }
        }

        > .c {

            flex: 1;

            &.show{
                position: absolute;
                left: 0;
                right: 0;
                top: 0;
            }

            text-align: center;
            font-size: @26px;
            color: @fontColorA3;
            z-index: 1;

            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;

            > span {
                color: var(--themColor);
            }
        }

        > .r {
            float: right;
            padding: 0 @spacingNumber;
            position: relative;
            z-index: 2;
            flex-shrink: 0;
            > .iconfont {
                font-size: @38px;
                color: @fontColorA2;
            }
        }

    }

    .brt-poi-list-bom-drawer {
        .absolute(bottom);
        /*position: relative;*/
        pointer-events: auto;
        background-color: #ffffff;
        box-shadow: 0 0 @shadowSize @shadowColor;
        display: flex;
        flex-direction: column;
        transition: height .2s linear;

        &.hide {
            box-shadow: none;
            transform: translateY(100%);
        }

        &.show{
            position: relative;
        }
        > .brt-plb-head {
            @height: @90px;

            height: @height;
            line-height: @height;
            overflow: hidden;
            border-bottom: 1px solid @borderColorA2;

            > .style-1 {
                overflow: hidden;
                position: relative;
                padding: 0 @spacingNumber;

                &:after {
                    display: inline-block;
                    font-family: iconfont !important;
                    content: '\e6f5';
                    line-height: @20px;
                    position: absolute;
                    top: @8px;
                    left: 50%;
                    transform: translateX(-50%);
                    font-size: @26px;
                    color: @fontColorA3;
                }

                > .l {
                    float: left;
                    color: @fontColorA3;
                    max-width: 70%;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;

                    > span {
                        color: var(--themColor);
                    }
                }

                > .r {
                    float: right;
                    color: @fontColorA2;

                    &:after {
                        display: inline-block;
                        content: '';
                        .triangle(bottom, @8px, @fontColorA3, 1);
                        vertical-align: middle;
                        margin-left: @5px;
                    }
                }
            }
        }

        > .brt-plb-body {
            flex: 1;
            overflow-y: auto;
            -webkit-overflow-scrolling: touch;
            min-height: 0.1px;

            > ul {
                padding: 0 @spacingNumber;

                > li {
                    display: flex;
                    align-items: center;
                    padding: @spacingNumber 0;
                    border-bottom: 1px solid @borderColorA2;
                    color: @fontColorA1;

                    &:active {
                        background-color: @activeBgColorA1;
                    }

                    > .content {
                        flex: 1;
                        min-width: 1px;

                        .t1 {
                            > span {
                                color: var(--themColor);

                                &.momcare{
                                    display: inline-block;
                                    padding: @8px @standartSpaceA4;
                                    background-color: @successColor;
                                    color: @themeReverseColor;
                                    border-radius: @radiusNumber;
                                    margin-right: @standartSpaceA1;
                                    font-size: @fontSizeA6;
                                    vertical-align: middle;

                                    &.block{
                                        background-color: @fontColorA3;
                                    }

                                }

                                &.distant{
                                    display: inline-block;
                                    padding: @8px @standartSpaceA4;
                                    background-color: #F6F3E7;
                                    color: @orangeColor;
                                    border-radius: @radiusNumber;
                                    font-size: @fontSizeA6;
                                    vertical-align: middle;
                                }

                            }
                        }
                        .t2{
                            >span:last-child{
                                margin-left: @standartSpaceA1;

                                >img{
                                    height: @50px;
                                    margin-right: @10px;
                                    vertical-align: middle;
                                }
                            }

                        }
                        .t2,
                        .t4 {
                            font-size: @28px;
                            color: @fontColorA2;
                            margin-top: @5px;
                        }

                        .t3 {
                            margin-top: @5px;
                        }
                    }

                    > .right {
                        font-size: 0;
                        > .logo {
                            width: @80px;
                        }
                    }
                }
            }

            > .none-box {
                padding: @80px 0;
                text-align: center;
                color: @fontColorA3;
            }
        }
    }

</style>
